<template>
  <v-container id="app-offline-choice">
    <h5 class="headline text-center">
      {{ $t('field.scan.program_selection') }}
    </h5>
    <v-card
      v-for="(program, index) in programs"
      :key="index"
      ripple
      class="ma-3"
      @click="setProgram(program)"
    >
      <h6 class="title text-center pt-2">
        {{ program.Name }}
      </h6>
      <v-card-text class="mt-0">
        <p
          v-if="program.Caution"
          class="ma-0"
        >
          {{ $t('field.scan.program_bail') }}: {{ program.Caution }}
        </p>
        <p
          v-if="program.Start"
          class="ma-0"
        >
          {{ $t('field.scan.program_date_start') }}: {{ program.Start.substring(0, 8) }}
        </p>
        <p
          v-if="program.Start"
          class="ma-0"
        >
          {{ $t('field.scan.program_hour_start') }}: {{ program.Start.substring(8) }}
        </p>
        <p
          v-if="program.End"
          class="ma-0"
        >
          {{ $t('field.scan.program_date_end') }}: {{ program.End.substring(0, 8) }}
        </p>
        <p
          v-if="program.End"
          class="ma-0"
        >
          {{ $t('field.scan.program_hour_end') }}: {{ program.End.substring(8) }}
        </p>
      </v-card-text>
    </v-card>
    <div class="mx-3">
      <v-btn
        class="bloc ma-0"
        @click="cancelInit"
      >
        {{ $t('words.cancel') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { Initialisation } from '@/modules/Initialisation'
import { $alert } from '@/modules/Utils'

export default {
  name: 'OfflineChoiceView',

  props: {
    programs: { type: Array, required: true },
    ticket: { type: Object, required: true }
  },

  methods: {
    setProgram (program) {
      Initialisation.initCashlessPlugin(
        program,
        this.ticket,
        (error) => {
          $alert(error)
        }
      )
    },
    cancelInit () {
      MetierLocalStorage.clear()
      this.$store.dispatch('clear')

      this.$router.replace('/')
    }
  }
}
</script>
